export default {
  setItens(state, payload) {
    state.itens = payload;
  },
  setTabela(state, payload) {
    state.selects.tabela = payload;
  },
  setColuna(state, payload) {
    state.selects.coluna = payload;
  }
};
